export type AuRetailerId = 'jbhifi';

export type AuRetailer = {
  id: AuRetailerId;
  url: string;
  /** Swap in the retailer-approved wordmark once artwork is available. */
  logoSrc?: string;
};

/**
 * Australia sale window: 29 September – 4 October 2026, Sydney time.
 * NSW is on AEST (UTC+10) until DST starts on 4 Oct, so the exclusive end
 * bound (midnight after 4 Oct) falls on AEDT (UTC+11).
 */
export const AU_SALE_STARTS_AT = Date.parse('2026-09-29T00:00:00+10:00');
export const AU_SALE_ENDS_AT = Date.parse('2026-10-05T00:00:00+11:00');

export const isAuSaleLive = (now: number = Date.now()): boolean =>
  now >= AU_SALE_STARTS_AT && now < AU_SALE_ENDS_AT;

/**
 * QA override: ?auSalePreview=1 bypasses the date gate so the popup can be
 * demoed outside the sale window. Only honored on localhost and Vercel
 * previews — production ignores it so the offer can't be triggered early.
 * Shared with NonMCFRing so the sizing-kit popup stays suppressed in
 * preview demos too.
 */
export const isAuSalePreviewOverride = (): boolean => {
  try {
    const host = window.location.hostname;
    const isNonProdHost = host === 'localhost' || host.endsWith('.vercel.app');
    return (
      isNonProdHost &&
      new URLSearchParams(window.location.search).get('auSalePreview') === '1'
    );
  } catch {
    return false;
  }
};

const UTM_PARAMS = {
  utm_source: 'ultrahuman',
  utm_medium: 'site-banner',
  utm_campaign: 'au-promo-sep26',
} as const;

const withUtms = (baseUrl: string, retailer: AuRetailerId): string => {
  const url = new URL(baseUrl);
  Object.entries(UTM_PARAMS).forEach(([key, value]) => {
    url.searchParams.set(key, value);
  });
  url.searchParams.set('utm_content', retailer);
  return url.toString();
};

export const AU_RETAILERS: AuRetailer[] = [
  {
    id: 'jbhifi',
    url: withUtms(
      'https://www.jbhifi.com.au/collections/health-fitness-wearables/ultrahuman-smart-ring',
      'jbhifi',
    ),
  },
];
